export interface HeaderStep {
    urlView: string;
    icon: string;
    newChargeStepType: NewChargeStepType;
    contextFieldToResetIfGoingPreviousStep: string[];
    selected?: boolean;
    complete?: boolean;
    isNotIonIcon?: boolean;
}

export enum NewChargeStepType {
    STATION_CHOICE,
    PLUG_TYPE_CHOICE,
    CHARGE_AREA_CHOICE,
    RESERVATION_CHOICE,
    MEDIA_CHOICE,
    SUMMARY
}
